var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ridership-by-route-chart"},[(!_vm.hasData)?_c('div',{staticClass:"text-center text-muted py-5"},[_vm._v(" "+_vm._s(_vm.$t('flexigo.ridership.noData'))+" ")]):_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }